import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { NgIf } from '@angular/common';
import { DevToolService } from 'lib';

@Component({
    selector: 'mmoga-home',
    imports: [
        RouterLinkActive,
        RouterOutlet,
        RouterLink,
        NgIf
    ],
    templateUrl: './home.component.html',
    standalone: true,
    styleUrl: './home.component.scss'
})
export class HomeComponent {
    private readonly devToolService = inject(DevToolService);


    get isDevtoolEnabled(): boolean {
        return this.devToolService.validateAccess();
    }
}
